import styled from 'styled-components';

export const FooterTextStyled = styled.p`
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: 12px;
  text-align: center;
  color: ${({ theme }) => theme.colors.typography400};
`;
